export const regionNameInternational: string =  'International';

export enum regionId {
  IT = 13
}

export function isItalianMarket(regionIds: number[]|undefined): boolean {
  if (regionIds !== undefined) {
    if (regionIds.includes(regionId.IT) && regionIds.length === 1)
      return true;
  }

  return false;
}
